enum StorageKey {
  LeadOriginUrl = 'leadOriginUrl',
}

export default StorageKey;
